import { useState } from "react";

const API_URL = process.env.REACT_APP_API_URL;

export default function TripFeedbackCard({
  source = "Overview Dashboard",
}) {
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async () => {
    if (!message.trim()) return;

    try {
      setLoading(true);

      await fetch(`${API_URL}/api/feedback`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          message,
          source,
        }),
      });

      setSent(true);
      setMessage("");
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white border border-gray-100 rounded-[2rem] p-6 md:p-8 shadow-sm">

      <h3 className="text-xl font-bold text-gray-900 mb-2">
        Need Help?
      </h3>

      <p className="text-sm text-gray-500 mb-5">
        Facing any issue or have a suggestion for this trip?
      </p>

      <div className="flex flex-col md:flex-row gap-3">

        <input
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="Tell us your issue or feedback..."
          className="
            flex-1
            rounded-2xl
            border border-gray-200
            px-5 py-4
            text-sm
            outline-none
            focus:border-[#5b6f00]
          "
        />

        <button
          onClick={handleSubmit}
          disabled={loading}
          className="
            px-6 py-4
            rounded-2xl
            bg-[#5b6f00]
            text-white
            text-sm
            font-bold
            hover:bg-[#4a5a00]
            transition
          "
        >
          {loading ? "Sending..." : "Send"}
        </button>

      </div>

      {sent && (
        <p className="text-sm text-[#5b6f00] mt-4 font-medium">
          ✅ Feedback sent successfully
        </p>
      )}

    </div>
  );
}